/// <amd-module name="SuiteCommerce.ProductComparison.Common"/>
define("SuiteCommerce.ProductComparison.Common", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
});
